import React from 'react';
import type { TextFieldProps } from '@mui/material';
import { Box, FormHelperText, TextField } from '@mui/material';
import * as Ramda from 'ramda';
import useTypingTimeout from '../../../hooks/useTypingTimeout';
import type { Nullable } from '../../../../../../../../../types/common/utility';
import { CleaveInput } from '../../../../../../../../../components/inputs/CurrencyField';
import { stripSpecialChars } from '../../coverages/modals/shared/common';

type Props = {
  value: any;
  onChange: (input: any) => void;
  min: Nullable<number>;
  max: Nullable<number>;
  step: Nullable<number>;
} & Omit<TextFieldProps, 'onChange' | 'value'>;

const RetentionField = ({
  value,
  onChange,
  name = 'deductible',
  min,
  max,
  step,
  ...props
}: Props) => {
  const validateInput = (value: number) => {
    if (!Ramda.isNil(min) && !Ramda.isNil(max)) {
      if (value < min || value > max) {
        return 'Invalid';
      }

      if (step && value % step !== 0) {
        return 'Invalid';
      }
    }
  };

  const typingTimeout = useTypingTimeout(
    (_value) => {
      onChange({
        [name]: {
          value: Number(_value),
        },
      });
    },
    {
      validate: validateInput,
      defaultValue: value,
    }
  );
  return (
    <Box sx={{ position: 'relative' }}>
      <TextField
        variant="outlined"
        size="small"
        name={name}
        disabled={min === max}
        value={typingTimeout.input}
        InputProps={{
          inputComponent: CleaveInput,
        }}
        onChange={(e) => {
          e.stopPropagation();
          typingTimeout.onChange(stripSpecialChars('', e.target.value));
        }}
        onFocus={(e) => e.stopPropagation()}
        onClick={(e) => e.stopPropagation()}
        sx={{
          '& .MuiInputBase-input': {
            background: 'transparent',
          },
          '& .Mui-disabled': {
            opacity: 0.5,
          },
        }}
        {...props}
      />
      {typingTimeout.error && (
        <FormHelperText
          style={{
            position: 'absolute',
            top: 30,
            marginLeft: '0.5rem',
            zIndex: 1,
          }}
        >
          {typingTimeout.error}
        </FormHelperText>
      )}
    </Box>
  );
};

export default RetentionField;
